export const INTERSECTION = {
  OUTSIDE: -1,
  INTERSECTING: 0,
  INSIDE: 1
};
//# sourceMappingURL=constants.js.map